import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";

const TwoFANotification: FC<NotificationViewProps> = ({
  onClose,
  notification,
}) => {
  const translations = notification.data.translations;
  const handleEnableClick = () => {
    window.dispatchEvent(new CustomEvent("openTwoFA"));
    onClose();
  };
  return (
    <div
      data-testid="2fa-notification"
      className="grid w-[stretch] gap-4 rounded-xl bg-secondary p-4 text-left shadow-md rtl:text-right md:w-80 md:p-6"
    >
      <div className="grid gap-2">
        <h4 className="text-base font-medium text-foreground">
          {translations["profile.make_your_account_more_secure"]}
        </h4>
        <p
          className="text-base text-foreground"
          dangerouslySetInnerHTML={{
            __html: translations["profile.turn_on_2fa"],
          }}
        />
        <div className="mt-3 flex flex-row justify-end">
          <Button
            onClick={onClose}
            className="bg-transparent text-base text-muted-foreground -my-2"
          >
            {translations["general.cancel"]}
          </Button>
          <Button
            onClick={handleEnableClick}
            className="h-auto bg-transparent -mx-4 -my-2"
          >
            <p className="text-base text-primary">
              {translations["general.enable"]}
            </p>
          </Button>
        </div>
      </div>
    </div>
  );
};
export default TwoFANotification;
